import { createContext } from "react";
import { Trainer } from "../../generated/graphql";

export const initialTrainerData: Trainer = {
    id: undefined,
    name: undefined,
    description: undefined,
    dictionaries: undefined,
    accessType: undefined,
    price: undefined,
    previewImage: undefined,
    webpGifImage: undefined,
    mp4GifImage: undefined,
    androidBundle: undefined,
    androidManifest: undefined,
    iosBundle: undefined,
    iosManifest: undefined,
    webGlBundle: undefined,
    webGlManifest: undefined,
    isPublished: undefined,
    canPublish: undefined,
};

export const TrainerContext = createContext({
    data: initialTrainerData,
    updateTrainerData: (key: string, value: string | number | File) => {},
});
